export enum CountrySearchStatusEnum{
    NO_CS = "No common services",
    NO_COUNTRIES = "No availble countries",
    HAS_COUNTRIES = "Available countries found"
}